import { useEffect, useState } from "react";
import styles from "./PublicMapScreen.module.css";
import { UserInfo as UserInfoType } from "../components/common/Common";
import ScreenTitle from "../components/common/ScreenTitle";
import MapListView from "../components/common/MapListView";
import RecommendationList from "../components/publicmap/RecommendationList";
import { RecommendationListItemProps } from "../components/publicmap/RecommendationListItem";

import DataProvider from "../data_provider/DataProvider";
import { ListSearchReqBody } from "../data_provider/gateways/MapGateway";
import { Helmet } from "react-helmet-async";

/**
 * @author bakim
 * @date 2024-08-20 10:38:12
 * @remark 공개지도 화면
 * @return <PublicMapScreen>
 */
function PublicMapScreen() {
    const [recoData, setRecoData] = useState<RecommendationListItemProps[]>([]);
    const [userInfo, setUserInfo] = useState<UserInfoType>();

    useEffect(() => {
        getUserInfo();
        loadRecoData();
    }, []);

    const getUserInfo = async () => {
        DataProvider.GetUserInfo().then((response) => {
            response.flag && setUserInfo(response.result);
        });
    };
    const fetchRecoData = async () => {
        const res = await DataProvider.GetRecommendMapList();
        if (!res.flag || !res.result) return [];

        return res.result;
    };

    /**
     * 공개 지도 조회 조회
     * @param no: 페이지 넘버
     * @returns MapItem[]
     */
    const getPublicMapList = async (body: ListSearchReqBody) => {
        return await DataProvider.GetMapList(body);
    };

    // 추천 지도
    const loadRecoData = async () => {
        const _recoData = await fetchRecoData();
        if (_recoData) {
            setRecoData(_recoData);
        }
    };

    return (
        <>
            <Helmet>
                <title>공개지도 - 모두의지도</title>
                <meta name="description" content="다른 유저들이 만든 지도를 탐색해보세요" />

                <meta property="og:type" content="website" />
                <meta name="title" property="og:title" content="공개지도 - 모두의지도" />
                <meta name="description" property="og:description" content="다른 유저들이 만든 지도를 탐색해보세요" />
                <meta name="imgage" property="og:image" content="https://modoomap.com/publicMaps.jpg" />
                <meta name="url" property="og:url" content="https://modoomap.com/public" />
            </Helmet>
            <div className={styles.container}>
                <ScreenTitle title="공개지도" />
                {recoData.length > 0 && <RecommendationList items={recoData} />}
                <MapListView title="공개지도목록" userInfo={userInfo} updateData={getPublicMapList} />
            </div>
        </>
    );
}

export default PublicMapScreen;
